<template>
  <div>{{ ActDescBtn }}
    <table style="position: absolute;" width="100%" :height="this.windowSize.height - 9"
      :max-height="this.windowSize.height - 9">
      <!-- ContenidoBase-Generar documentos -->
      <ContenidoBase :titulo="'Generar documentos recurrentes'"
        :descripcion="'Generación automática de facturas y pre-facturas a partir de las configuraciones pre-registradas.'"
        :EstadoBtn="EstadoBtn" @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="newwnuevo" @MethodGuardar="save"
        @MethodEliminar="remove" @MethodAnular="anular" @MethodImprimir="imprimirList" />
      <!-- fn ContenidoBase-Generar documentos -->

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraTablaDinamicaAprir">

          <div class="overflow-y-auto "
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn small color="yellow accent-4" @click.prevent="actualiza_tb_ver">
                      <i style="font-size: 25px;" class="fa fa-eye"> </i> ver
                    </v-btn>
                    <v-btn small dark color="deep-purple accent-2"
                      @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                      <i style="font-size: 25px;" class="fa fa-print"> </i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
              </template>
            </v-tooltip>

          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto "
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">


            <v-container>
              <v-card color="grey lighten-3">

                <v-toolbar flat color="#BDBDBD" dense style="border: 1px solid #000000;">


                  <v-avatar tile size="45">
                    <img src="@/assets/iconos_micromarket/custom-reports.png" alt="Reporte">
                  </v-avatar>


                  <span class="font-weight-light" style="font-size: 20px;"> Generar documentos recurrentes </span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
                </v-toolbar>

                <hr>

                <v-container style="border: 1px solid #000000;">
                   <!-- Formulario-Generar documentos  -->
                  <v-form ref="formGenerar" @submit.prevent="" v-model="valid" lazy-validation>
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  desde  -->
                        <v-text-field dense outlined type="date" label="Fecha:" :rules="[$rules.required]"
                          v-model="GenerarRecurrente.fecha">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-calendar"></i>
                          </template>
                        </v-text-field>


                      </v-col>
                      <!-- fn columna 1 -->


                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">

                        <!-------------------------------------------------- Proyecto -->
                        <v-combobox autocomplete="off" dense outlined style="font-size:13px;" label="Proyecto"
                          :items="Rproyecto" item-text="nombre" :rules="[$rules.required]"
                          v-model="GenerarRecurrente.proyecto" @blur="SelctCbProyecto" @focus="cargarProyecto">

                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-area-chart"></i>
                          </template>

                        </v-combobox>


                      </v-col>
                      <!-- fn columna 2 -->

                      <v-col cols="12" md="12" sm="12">

                        <!------------------------------- Comentario-->
                        <v-textarea v-model="GenerarRecurrente.comentario" label="Comentario " style="font-size:13px;"
                          rows="1" outlined dense>
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-comments-o"></i>
                          </template>
                        </v-textarea>




                      </v-col>




                    </v-row>

                  </v-form>
                  <!-- Formulario-Generar documentos  -->
                </v-container>

                <hr>

                <v-toolbar flat color="#BDBDBD" dense style="border: 1px solid #000000;" class="d-flex justify-center">

                  <v-btn-toggle dense rounded>
                    <!--  -->
                    <v-btn dark color="green darken-3" @click.prevent="GenerarDocumento">
                      <i style="font-size: 28px;" class="fa fa-retweet"> </i>
                      Generar
                    </v-btn>

                    <v-btn dark color="light-blue darken-2" @click.prevent="ImprimirFacturasGeneradas">
                      <i style="font-size: 28px;" class="fa fa-print"> </i>
                      Imprimir Facturas Generadas
                    </v-btn>
                    <v-btn dark color="light-blue accent-2" target="_blank"
                      @click.prevent="ImprimirPreFacturasGeneradas">
                      <i style="font-size: 28px;" class="fa fa-print"> </i>
                      Imprimir Pre-Facturas Generadas
                    </v-btn>

                  </v-btn-toggle>
                </v-toolbar>

              </v-card>
            </v-container>

          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraSecundariaAprir">

          <div class="overflow-y-auto "
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog label="myAlert" v-model="acti_tb_data" persistent max-width="100%" max-height="100%"
      transition="fab-transition">
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" @keyup="filtro" label="Buscar" single-line hide-details>
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" dense :items="list" :search="search" @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog label="myAlert" v-model="Elim_notif.estado" persistent max-width="350" transition="fab-transition">
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
          " small>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true"
      :timeout="120000" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <div v-show="false" class="overflow-x-auto">
      <!-- columna  ---------------------->
      <ComponentsConsultaGenFacElect ref="RefComponentsConsultaGenFacElect"/>
    </div>

    <div v-show="false" class="overflow-x-auto">
      <!-- columna  ---------------------->
      <ComponentsUtilitarioFacturaVentas ref="RefComponentsUtilitarioFacturaVentas"/>
    </div>

    
     <v-dialog v-model="dialogContrato" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
            <v-card class="mx-auto">
              <v-col class="pa-0 ma-0 py-0 my-0 d-flex justify-end" cols="12" md="12" sm="12"
                     style="background-color: #dd4b39">
                <v-btn color="grey darken-4" fab x-small @click="dialogContrato=false">
                  <i class="fa fa-close" style="font-size: 20px; color: white"></i>
                </v-btn>
              </v-col>
    
              <v-list subheader three-line>

                 <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" >
                    <v-col style="background-color:#1A237E;" class="pa-0 ma-0 py-0 my-0 px-2" cols="12" md="12" sm="12">
                               <span :class="`d-flex justify-start white--text`"> <b>CONTRATO RECURRENTE</b></span>
                     </v-col>
                  <div class="px-2 py-1">
                  <v-card color="grey lighten-3">
                    
                   <div class="px-2 pb-2" style="border: 1px solid #000000">
                      <v-form ref="formConsFilt" v-model="valid" lazy-validation @submit.prevent="">
                      <v-col class="pa-0 ma-0 py-0 my-0 pt-2" cols="12" md="12" sm="12">
                        <v-row class="pa-0 ma-0 py-0 my-0">

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="2" sm="2">
                          <!-------------------------------------------------- numero contraro -->
                          <v-text-field v-model="ConsultaFiltro.contrato" autocomplete="off" placeholder=" "
                            style="font-size:13px;" label="No.Contrato" outlined dense>

                            <template v-slot:prepend>

                              <i style="font-size: 30px;" class="fa fa-file-text-o"></i>

                            </template>
                          </v-text-field>
                        </v-col>

                            <!-- @input="getContratoList" v-on:input="resertPaginacion"  -->
                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="5" sm="5">
                            <v-text-field
                              id="fecha-inicial"
                              v-model="ConsultaFiltro.fechaInicial"
                              :rules="[$rules.required]"
                              dense
                              label="Fecha Inicial"
                              outlined
                              placeholder=" "
                              style="font-size: 12px"
                              type="date"
                              @blur="BlurDesde"
                              >
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </v-col>

                         <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="5" sm="5">
                          <!-- @input="getContratoList" v-on:input="resertPaginacion" -->
                          <v-text-field
                              v-model="ConsultaFiltro.fechaFinal"
                              :rules="[$rules.required]"
                              dense
                              label="Fecha Final"
                              outlined
                              placeholder=" "
                              style="font-size: 12px"
                              type="date"
                              @blur="BlurHasta">
                            <template v-slot:prepend>
                              <i class="fa fa-calendar" style="font-size: 18px"></i>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="6" sm="6">
                      <v-combobox autocomplete="off" style="font-size:13px;" dense outlined label="cliente:"
                        :items="RCliente" item-text="codnom"  :suffix="BasicclientTel"
                        v-model="ConsultaFiltro.cliente" @blur="SelctCbClienteConsultFilt" @focus="cargarCliente"
                        @keyup="CbFilcliente" @change="ClienteSelectTel" no-filter>

                        <template slot="item" slot-scope="item">
                  <span style="display:none;">{{ item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} ` }}</span>
                  <span class="fontSize13"><b>{{ item.item.codigo}}</b> - {{item.item.nombre.trim()}}</span>
                  </template>

                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <span class="fontSize13 colorNombre"><b>{{ item.codigo}}</b> - {{item.nombre}}</span>
                  </template>
                        <template v-slot:prepend>
                          <i style="font-size: 20px;" class="fa fa-user-circle"></i>
                        </template>
                      </v-combobox>
                        </v-col>
                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="5" sm="5">
                           <!-------------------------------------------------- Proyecto -->
                          <v-combobox autocomplete="off" dense outlined label="Proyecto" :items="Rproyecto" item-text="nombre"
                             v-model="ConsultaFiltro.proyecto" @blur="SelctCbProyectoFiltro"
                            @focus="cargarProyecto">

                            <template v-slot:prepend>
                              <i style="font-size: 20px;" class="fa fa-area-chart"></i>
                            </template>
                          </v-combobox>
                        </v-col>

                        <v-col class="pa-0 ma-0 px-2 py-1" cols="12" md="1" sm="1">
                        <v-btn color="teal" small @click.prevent="buscarConsultaFacRecurrent">
                          <i class="fa fa-search" style="font-size: 20px;"></i>
                        </v-btn>
                        </v-col>


                        </v-row>
                      </v-col>
                      </v-form>
                    </div>
                    </v-card>
                       </div> 
                 </v-col>

                 <v-col class=" px-2 pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" >
                  <v-card color="grey lighten-3">
                <div class="px-2 pt-1" style="border: 1px solid #000000">
                   <v-lazy  v-model="isActive" :options="{  threshold: .5 }" min-height="500"  transition="fade-transition">
                    
                    
                    <v-data-table
                          v-if="resertPagi == true"
                          id="facturas-table"
                          :footer-props="$arrayPropiedasesGlobal"
                          :headers="[
                          { text: 'CÓDIGO', sortable: false, value: 'id', width: 120 , class: ['no-gutters black--text'] },
                          { text: 'FECHA REGISTRO', sortable: false, value: 'nuevaFechaRegistro', width: 150 , class: ['no-gutters black--text'] },
                          { text: '#CONTRATO', sortable: false, value: 'contrato', width: 200,class: ['no-gutters black--text'] },
                          { text: 'CLIENTE', sortable: false, value: 'cliente', width: 200,class: ['no-gutters black--text'] },
                          { text: 'PROYECTO', sortable: false, value: 'proyecto', width: 200,class: ['no-gutters black--text'] },
                          { text: 'INICIO // FINAL', sortable: false, value: 'fecInicFinal', width: 'auto' , class: ['no-gutters black--text'] },
                          { text: 'REPETIR CADA', sortable: false, value: 'frecuencia', width: 129, class: ['no-gutters black--text'] },
                          { text: 'FRECUENCIA', sortable: false, value: 'tipoTiempo', width: 129, class: ['no-gutters black--text'] },

                          // { text: 'Estado', sortable: false, value: 'estado', width: 150, class: ['no-gutters black--text'] },
                          // { text: 'Activo/Anulado', sortable: false, value: 'activoanulado', width: 80, class: ['no-gutters black--text'] },
                        ]"
                          :items="listContrato"
                          :items-per-page="paginator.itemsPerPage"
                          :search="search"
                          :server-items-length="TotalRegistros"
                          class="elevation-1 RowSelectColor TbSize13"
                          dense
                          item-key="indx"
                          @pagination="cargarPaginacion"
                          @click:row="datostabla"
                          show-expand  
                          :single-expand="true" 
                          :expanded.sync="expanded" 
                          @item-expanded="getListFactcontrato"
                      >
                        <template v-slot:item.action="{ item }">
                          <!-- <v-btn fab @click.prevent="VerReporte(item)" x-small color="yellow accent-4"><i style="font-size: 20px;" class="fa fa-eye"></i></v-btn>  -->
                          <!-- <v-btn color="red darken-3" fab x-small @click.prevent="deleFact(item)">
                            <i class="fa fa-trash-o" style="font-size: 20px"></i>
                          </v-btn> -->
                        </template>

                        <template v-slot:item.nuevaFechaRegistro="props">
                          <span style="font-size: 13px; display: none">
                            {{ (props.item.indx = `${listContrato.indexOf(props.item)}-${props.item.id}`) }}
                          </span>
                          <span style="font-size: 13px">{{ FormatoFecha(props.item.nuevaFechaRegistro)}}</span>
                        <!-- FormatoFecha(props.item.fecha) -->
                        </template>

                        <template v-slot:item.cliente="props">
                          <span style="font-size: 13px">{{ props.item.hasOwnProperty('cliente') && props.item.cliente!=null?props.item.cliente.nombre.trim():"N/A"}}</span>
                        </template>

                        <template v-slot:item.proyecto="props">
                          <span style="font-size: 13px">{{ props.item.hasOwnProperty('proyecto') && props.item.proyecto!=null?props.item.proyecto.nombre.trim():"N/A"}}</span>
                        </template>

                        <template v-slot:item.fecInicFinal="props">
                        <span style="font-size: 13px">{{ FormatoFecha(props.item.nuevaFechaDesde)}} // {{ FormatoFecha(props.item.nuevaFechaHasta)}} </span>
                        </template>

                       

                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="pa-0 ma-0 px-1 py-1" style="border: 1px dashed  #616161;">
                  <v-lazy :min-height="300"
             :options="{'threshold':0.5}"
              transition="fade-transition"  >
              <div style="border: 2px solid #757575; overflow: auto;  max-height:350px;  " class="overflow-y-auto">

                              <v-data-table
                                    :loading="loaderTabla"
                                    hide-default-footer
                                    class="RowSelectColor TbSize13" 
                                    item-key="indx"
                                    :headers="[
                                    { text: 'FACTURA', sortable: false, value: 'factura', class: ['no-gutters black--text'] },
                                    { text: 'FECHA', sortable: false, value: 'fecha', class: ['no-gutters black--text'] },
                                    { text: 'NCF', sortable: false, value: 'ncf', class: ['no-gutters black--text'] },
                                    { text: 'CLIENTE', sortable: false, value: 'cliente', class: ['no-gutters black--text'] },
                                    { text: 'VALOR', sortable: false, value: 'valor', class: ['no-gutters black--text'] },
                                    { text: 'ESTADO', sortable: false, value: 'estado', width: 180, class: ['no-gutters black--text'] },
                                    { text: 'ACCIÓN', value: 'action', width: 'auto', sortable:false, class: ['no-gutters black--text']  }
                                    
                                    ]"
                                            dense
                                            :items="listfactContrato"   
                                            :items-per-page="-1"
                                            v-if="SubTablaSoloItemsExpander(item)==true"
                                          >

                                        <template v-slot:item.factura="props"> 

                                             
                                        <span style="font-size:13px; display:none;">{{props.item.indx = `${listfactContrato.indexOf(props.item)}-${item.indx}`}}</span>
                                          <v-col  class="pa-0 ma-0 py-0 my-0"  cols="12" md="12" sm="12"> 
                                            <span style="font-size:13px;">{{ props.item.documentoFactura.nombrecorto.trim() }}-{{props.item.facturasventaPK.secuencia}} </span>
                                          </v-col>
                                        </template>

                                            <template v-slot:item.fecha="props">
                                            <v-col  class="pa-0 ma-0 py-0 my-0"  cols="12" md="12" sm="12"> 
                                              <span style="font-size:13px;">{{FormatoFecha(props.item.fecha)}} </span>
                                            </v-col>
                                            </template>

                                            <template v-slot:item.ncf="props">
                                            <v-col  class="pa-0 ma-0 py-0 my-0"  cols="12" md="12" sm="12"> 
                                            <span style="font-size: 13px">{{ props.item.hasOwnProperty('ncf') && props.item.ncf!=null?props.item.ncf.trim():"N/A"}}</span>
                                           </v-col>
                                          </template>

                                          <template v-slot:item.cliente="props">
                                            <v-col  class="pa-0 ma-0 py-0 my-0"  cols="12" md="12" sm="12"> 
                                            <span style="font-size: 13px">{{ props.item.hasOwnProperty('cliente') && props.item.cliente!=null?props.item.cliente.nombre.trim():"N/A"}}</span>
                                           </v-col>
                                          </template>

                                          <template v-slot:item.estado="props">
                                          <span style="font-size: 13px"> <b :class="claseColorEstado(props.item.trackId)">{{ getEstado(props.item.trackId) }}</b>
                                          </span>
                                         </template>

                                          <template v-slot:item.valor="props">
                                            <v-col  class="pa-0 ma-0 py-0 my-0"  cols="12" md="12" sm="12"> 
                                            <span style="font-size:13px;">{{ currencyFormatter(props.item.valor) }}</span>
                                          </v-col>
                                        </template>

                                        <template v-slot:item.action="{ item }">
                                          <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                              <v-btn v-on="on" fab @click.prevent="ImpPedi(item)" x-small color="blue lighten-3"><i
                                                  style="font-size: 20px" class="fa fa-print"></i></v-btn>
                                            </template>
                                            <span>IMPRIMIR REGISTRO </span>
                                          </v-tooltip>
                                        </template>

                            

                                          

                                    <template v-slot:no-data>
                                    <span class=" black--text" >SIN FACTURA</span>
                                    </template>
                              </v-data-table> 

                              </div>

</v-lazy>

                            </td>
                        </template>
                      </v-data-table>
                    

                    </v-lazy>
                </div>
              </v-card>
                 </v-col>
              
              </v-list>
            </v-card>
    
            <!----- fn Modal-Recibo de ingreso avanzado -->
     </v-dialog>

     <!-- ------------------------------------------------------ Modal- Notificacion Confirmacion Adicional -->
    <v-dialog transition="fab-transition" label="Modal Otros Ingresos" v-model="notifConfAdicional.estado" persistent
      max-width="60%" max-height="85%">

      <!--------------------- Creacion de Otros Ingresos ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

     
        <v-col style="background-color:#dd4b39;" class="pa-2 ma-0 py-1 my-0" cols="12" md="12" sm="12">
            <span style="font-size: 22px;"  :class="`d-flex justify-start white--text`"> <i dense class="fa fa-info-circle"> <b> NOTIFICACIÓN</b></i></span>
         </v-col>
        
        <v-card >
          <!-- style="border: 1px solid #000000;" -->
          <!-- columna informacion  -->
          <v-col style="border: 1px solid #000000;"   class="pa-0 ma-0 py-2 my-0" cols="12" md="12" sm="12" :class="`d-flex justify-center`">
            <center >
            <!-- <h2 class="py-5">  </h2> -->
              <code :class="`black--text`" style=" font-size: 25px;border: 1px solid #000000;">
              <b>{{ notifConfAdicional.nombre }}</b>
              </code>

              <v-col v-if="notifConfAdicional.Exec == 'contImpPdf'"  class="pa-0 ma-0 py-1 my-0" cols="12" md="12" sm="12" :class="`d-flex justify-center`">
                <!-------------------------------------------------- terminal -->
                        <!--:items="RSuplidor",@blur="SelctCbSuplidor", @focus="cargarSuplidor", @keyup="CbFilSuplidor" -->
                        <v-combobox autocomplete="off" dense outlined label="* Seleccione Impresora:" item-text="nombre"
                          :items="impList" @focus="cargarImpresoras" v-model="notifConfAdicional.Impresora"
                          hide-details @blur="SelctCbImpresora">
                          <template v-slot:prepend>
                            <i style="font-size: 20px" class="fa fa-trademark"></i>
                          </template>
                        </v-combobox>
              </v-col>
                <!--anularFactura(notifConfAdicional.objTemp)  -->
                <v-card-actions :class="`d-flex justify-center`">
                  
                <v-btn style="border: 1px solid #000000;"  color="blue" v-if="notifConfAdicional.Exec == 'contImpPdf'"
                  @click.prevent="imprimirPrint()" large>
                  <i style="font-size: 20px;" class="fa fa-print"></i> IMPRIMIR
                </v-btn>

                <v-btn style="border: 1px solid #000000;"  color="#BDBDBD" v-if="notifConfAdicional.Exec == 'contImpPdf'" 
                @click.prevent="reportePdf()" large>
                  <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i> REPORTE PDF
                </v-btn>

                <v-btn style="border: 1px solid #000000;"  color="orange" 
                @click.prevent="cerrarNotificacion" large>
                  <i style="font-size: 20px;" class="fa fa-reply-all"></i> CERRAR
                </v-btn>
                </v-card-actions>

          
            </center>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
     <!-- ------------------------------------------------------ FIN Modal- Notificacion Confirmacion Adicional  -->



    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import ComponentsConsultaGenFacElect from "@/ConsultasRapidas/ConsultaGeneralFactElectronica.vue"
import ComponentsUtilitarioFacturaVentas from "@/Utilitario/UtilitarioFacturaVentas.vue"
import { currencyFormatter, FormatoFecha, getParamFecha, HoraFormatter,fechaNueva } from "@/js/Funciones.js"
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ComponentsConsultaGenFacElect,
    ComponentsUtilitarioFacturaVentas

  },
  created() {

    var json = {
      titulo: "Generar documentos recurrentes",
      descripcion: "Generación automática de facturas y pre-facturas a partir de las configuraciones pre-registradas.",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi: false,
      accion: [

        "GenerarFacturasRecurrenteNew",
        "GenerarFacturasRecurrenteSave",
        "GenerarFacturasRecurrenteRemove",
        "GenerarFacturasRecurrenteAnular",
        "GenerarFacturasRecurrentePrintList"
      ],
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("GenerarFacturasRecurrenteNew", this.new);
    // EventBus.$on("GenerarFacturasRecurrenteSave", this.save);
    // EventBus.$on("GenerarFacturasRecurrenteRemove", this.remove);
    // EventBus.$on("GenerarFacturasRecurrenteAnular", this.remove);
    // EventBus.$on("GenerarFacturasRecurrentePrintList", this.imprimirList);
    EventBus.$on("emitGenerarFacturasRecurrente", this.datostabla);
    this.cargarTodo();


  },

  data: () => ({

    loaderTabla:false,
    dialogContrato:false,
    Rpropietario: [],
    Rproyecto: [],
    RCaja: [],
    ListaTiposClientes: [],
    RCliente:[],
    Rproyecto:[],
    impList:[],
    
    windowSize: { width: "auto", height: "auto" },
    BasicclientTel:'',
    isActive:false,

    notifConfAdicional: {
      estado: false,
      nombre: "",
      Exec: "",
      Impresora:null,
      objTemp:null
    },

    GenerarRecurrente: {
      fecha: new Date().toISOString().substr(0, 10),
      proyecto: null,
      comentario: ''

    },
    expanded:[],
    listfactContrato:[],
    listContrato:[],
    TotalRegistros: 1,
    resertPagi: true,
    paginator: {
      itemsPerPage: 15,
      pageStart: 1,
      page: 1,
      pageStop: 15,
      pageCount: 10,
      itemsLength: 5,
    },
    ConsultaFiltro:{
      contrato:null,
      fechaInicial: fechaNueva(),
      fechaFinal: fechaNueva(),
      secuencia: null,
      cliente: null,
      proyecto: null,

    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: true,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },



    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{ text: "Tipo Clientes", value: "descripcion" }],

    slotlist: [
      { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:"
      },
      { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
    ],

    slotHtabla: [
      { text: "Código", value: "codigo" },
      { text: "Descripcion", value: "descripcion" }
    ],

    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?"
    },

    aalert: {
      estado: false,
      color: null
    },

  }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
 currencyFormatter, FormatoFecha, HoraFormatter, getParamFecha,fechaNueva,
    abrirTabla() {
      console.log('verrrklk--->')
      this.dialogContrato=true

/**/var _this = this
setTimeout(function() {
              _this.getContratoList()
              //_this.getContratoList()
            // return true;
            }, 500)


     // this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },
    async cargarTodo() {
      // await this.$axios
      //   .post(
      //     this.$hostname +
      //       this.$hName +
      //       "/services/tipocliente/findalltipoclientes",
      //     {
      //       usuario:JSON.parse(JSON.stringify(this.$user)) 
      //     }
      //   )
      //   .then(res => (this.ListaTiposClientes = res.data))
      //   .catch(error => console.log(error));
    },
    datostabla(e) {

      this.GenerarRecurrente = e;
      this.acti_tb_data = false
    },
    save() {

      if (this.$refs.form.validate()) {

        var jsn = {
          datos: JSON.parse(JSON.stringify(this.GenerarRecurrente)),
          usuario: JSON.parse(JSON.stringify(this.$user))
        }
        this.$axios
          .post(
            this.$hostname +
            this.$hName +
            "/services/tipocliente/saveTipoCliente",
            JSON.parse(JSON.stringify(jsn))
          )
          .then(res => {

            if (res.data.includes("No se pudo generar")) {

              this.alerta("Dato guardado correctamente!", "warning");
            } else {
              this.alerta("Dato guardado correctamente!", "bien");
            }
          }).catch(error =>
            this.alerta("Dato no guardado", "error"
              // "hubo un error , por favor verifique el campo descripcion!",
              // "error"
            )
          );
      } else {
        this.alerta("Los campos en rojo son requeridos", "error");
      }




    },
    remove() {

      if (this.GenerarRecurrente.codigo != 0 && this.GenerarRecurrente.codigo != null) {

        this.Elim_notif.estado = !this.Elim_notif.estado;
      } else { this.alerta("Seleccione un tipo de cliente para eliminar", "error") }


    },
    eliminar() {

      var jsn = {
        datos: JSON.parse(JSON.stringify(this.GenerarRecurrente)),
        usuario: JSON.parse(JSON.stringify(this.$user))
      }

      if (this.GenerarRecurrente.codigo != 0) {
        this.$axios
          .post(
            this.$hostname +
            this.$hName +
            "/services/tipocliente/borradoTipoCliente",
            JSON.parse(JSON.stringify(jsn))
          )
          .then(res => { this.alerta(res.data.mensage, res.data.estado) })
          .catch(error =>
            this.alerta(
              // "hubo un error , por favor verifique el campo descripcion!"
              "Dato no eliminado",
              "error"
            )
          );
      }


    },
    anular() {
      if (this.Elim_notif.estado) {

        var jsn = {
          datos: JSON.parse(JSON.stringify(this.GenerarRecurrente)),
          usuario: JSON.parse(JSON.stringify(this.$user))
        }

        this.$axios
          .post(
            this.$hostname +
            this.$hName +
            "/services/tipocliente/removeTipoCliente",
            JSON.parse(JSON.stringify(jsn))
          )
          .then(res => this.alerta("Dato eliminado correctamente!", "bien"))
          .catch(error =>
            this.alerta(
              // "hubo un error , por favor verifique el campo descripcion!"
              "Dato no eliminado",
              "error"
            )
          );
      }
    },
    imprimirList() { },
    newwnuevo() {
      this.GenerarRecurrente = {
        fecha: null,
        proyecto: null,
        comentario: ''

      },
        EventBus.$emit("loading", false);
      EventBus.$emit("actualizaBarraBusqueda2");
    },



  // Realizar una solicitud GET al servidor y devolver los datos al componente Vue.
    cargarProyecto() {


      this.$axios.get(this.$hostname + this.$hName + '/Proyecto/findallActivos/', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.Rproyecto = res.data))

    },


    // Comprobando si el usuario ha seleccionado un proyecto de la lista desplegable. Si el usuario no
    // ha seleccionado un proyecto, se mostrará un mensaje de error.
    SelctCbProyecto() {

      if (this.GenerarRecurrente.proyecto == null) {

        this.GenerarRecurrente.proyecto = ''
      }

      if (this.GenerarRecurrente.proyecto.id == undefined) {

        this.alerta("Seleccione un proyecto", "error");
        this.GenerarRecurrente.proyecto = ''
        return

      }

    },


    BlurDesde() {

      if (this.GenerarRecurrente.fecha.toString().length == 0) {
        this.GenerarRecurrente.fecha = new Date().toISOString().substr(0, 10)
      }

    },

    // Envío de una solicitud GET al servidor para generar los documentos recurrente.
    GenerarDocumento() {

      if (this.$refs.formGenerar.validate()) {
        EventBus.$emit("loading", true);


        var com = this.GenerarRecurrente.comentario.trim()
        if (com.length == 0) {
          com = 'null'
        }

        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/configuracion-recurrente/generarFacturasRecurrentes",
            {
              headers: this.$store.getters.GetheadersAxios,
              params: {
                fecha: this.GenerarRecurrente.fecha,
                proyecto: this.GenerarRecurrente.proyecto.id,
                comentario: com
              }
            }
          )
          .then(res => {
            console.log('ver-Resp-DATA->',res.data)
            if (res.data.mensaje.includes("No se pudo generar")) {
              this.alerta(res.data.mensaje, "warning");
            } else {
              if(res.data.facturas==true){
                this.envioFactEletronico(res.data.listaFaCon)
              }
             


              this.alerta("Dato guardado correctamente!", "bien");
            }
            EventBus.$emit("loading", false);
          })
          .catch(error => { EventBus.$emit("loading", false); }
          );

      } else {

        this.alerta("los campos en rojo son Requeridos", "error");

      }


    },

    // Abriendo una nueva ventana y escribiendo el pdf en ella.
    ImprimirFacturasGeneradas() {


      if (this.$refs.formGenerar.validate()) {
        EventBus.$emit("loading", true);
        var fech = this.GenerarRecurrente.fecha
        var proy = this.GenerarRecurrente.proyecto.id
        var headers = this.$store.getters.GetheadersAxios
        this.$axios.get(this.$hostname + this.$hName + "/configuracion-recurrente/ImprimirGenerarFacturasRecurrentes/" + fech + "/" + proy, { headers: headers }).then(res => {
          EventBus.$emit("loading", false);
          /*let pdfWindow = window.open("Reporte de imprecion")
          pdfWindow.document.write("<embed width='100%' height='100%' type='application/pdf'   src='data:application/pdf;base64," +
            encodeURI(res.data) + "'></embed>")*/
            var PDF=`data:application/pdf;base64,${encodeURI(res.data)}`;
            EventBus.$emit("openPDF",PDF ,'conf recurrente');

        })
          .catch(error => { EventBus.$emit("loading", false); }
          );

      } else {
        this.alerta("los campos en rojo son Requeridos", "error");
      }

    },

   // Abriendo una nueva ventana y escribiendo el pdf en ella.
    ImprimirPreFacturasGeneradas() {

      if (this.$refs.formGenerar.validate()) {
        EventBus.$emit("loading", true);
        var fech = this.GenerarRecurrente.fecha
        var proy = this.GenerarRecurrente.proyecto.id
        var headers = this.$store.getters.GetheadersAxios
        this.$axios.get(this.$hostname + this.$hName + "/configuracion-recurrente/ImprimirGenerarPreFacturasRecurrentes/" + fech + "/" + proy, { headers: headers }).then(res => {
          EventBus.$emit("loading", false);
          /*let pdfWindow = window.open("Reporte de imprecion")
          pdfWindow.document.write("<embed width='100%' height='100%' type='application/pdf'   src='data:application/pdf;base64," +
            encodeURI(res.data) + "'></embed>")*/

            var PDF=`data:application/pdf;base64,${encodeURI(res.data)}`;
             EventBus.$emit("openPDF",PDF ,'generer prefacturas recurrente');

        })
          .catch(error => { EventBus.$emit("loading", false); }
          );


      } else {

        this.alerta("los campos en rojo son Requeridos", "error");

      }

    },


  

   async envioFactEletronico(DATA){
    var NEW_ARRAYS=[]
      await Promise.all(DATA.map(async (element) => {
        var OBT={
          factura:element,
          qrdgii:element.qrdgii,
          signatureValue:element.signatureValue,
          trackId:element.trackId,
          fechafirmadgii:element.fechafirmadgii,
          tiporegistro:"factura",
          ncf:element.ncf,
          valor: element.valor,
          activo: element.activada
        }
        NEW_ARRAYS.push(OBT)
            }))

    
  // var resObjCompleto = await this.$refs.RefComponentsConsultaGenFacElect.contEnviarTodaFactura(NEW_ARRAYS)
  var resObjCompleto = await this.contEnviarTodaFactura(NEW_ARRAYS)
    // EventBus.$emit("loading", false)
    },

    async contEnviarTodaFactura(DATALIST){

EventBus.$emit("loading", true) 

  if(DATALIST.length>0){
var TIPO_ECF_ARRYS=['E31','E32','E45','E44','E33','E34','E43','E46','E47']

 var LIST_FAC= DATALIST.filter((ee) => ee.activo==true && ee.tiporegistro.trim() === "factura" && TIPO_ECF_ARRYS.some(tipo => ee.hasOwnProperty('ncf') && ee.ncf!=null && ee.ncf.startsWith(tipo)) && ee.factura.trackId ==null || ee.factura.trackId !=null  &&  !ee.factura.trackId.includes("estado"))
    if(LIST_FAC.length==0){
      this.alerta("En esta lista No hay facturas para enviar!", "error");
      return 
    }
    
var ListtrackId=[]
await Promise.all(LIST_FAC.map(async (element) => {
      if(element.tiporegistro==="factura"){
       var resObjCompleto = await this.$refs.RefComponentsUtilitarioFacturaVentas.facturacionEletronicaGet(element.factura)       
        // trackId= resObjCompleto.objtrackId!=null?JSON.stringify(resObjCompleto.objtrackId).toUpperCase():"";    
        ListtrackId.push(resObjCompleto)
      }
}))

var _this = this

setTimeout(function() {
              _this.alerta(` PROCESO EJECUTADO CORRECTAMENTE !!! `, "bien")
              //_this.getContratoList()
              EventBus.$emit("loading", false)
            // return true;
            }, 500)

  }else{
     this.alerta("En esta lista No hay facturas para enviar!", "error");
     EventBus.$emit("loading", false)
     //return false;
  }


},


 resertPaginacion() {
      this.resertPagi = false

      this.paginator.page = 1
      this.paginator.pageStart = 0
      this.paginator.pageStop = this.paginator.itemsPerPage

      var _this = this
      setTimeout(function () {
        _this.resertPagi = true
      }, 500)

      //setTimeout(this.resertPagi=true,1500);
    },

    cargarPaginacion(e) {
      // console.log('cargarPaginacion')
      //     console.log(e);
      this.paginator = e

      if (this.paginator.itemsPerPage == -1) {
        this.paginator.itemsPerPage = 15
        // this.paginator.itemsPerPage.push(15)
      }

      this.getContratoList()
      //   this.filtro();
    },



getContratoList() {
      // if(this.ConsultaFiltro.NoFactura.length==0){this.ConsultaFiltro.NoFactura=0}

      if (
      (this.ConsultaFiltro.contrato != null && this.ConsultaFiltro.contrato.length == 0) ||  this.ConsultaFiltro.contrato == 0
      ) {
        this.ConsultaFiltro.contrato = null
      }
     
      if (this.$refs.formConsFilt.validate()) {
 
        var obj = JSON.parse(JSON.stringify(this.ConsultaFiltro))
       if(this.ConsultaFiltro.proyecto!=null){obj.proyecto=this.ConsultaFiltro.proyecto.id}
       if(this.ConsultaFiltro.cliente!=null){obj.cliente=this.ConsultaFiltro.cliente.codigo}
        // if (this.ConsultaFiltro.documento != null) {
        //   obj.documento = this.ConsultaFiltro.documento.codigo
        // }
        // if (this.ConsultaFiltro.cliente != null) {
        //   obj.cliente = this.ConsultaFiltro.cliente.codigo
        // }
        obj.limit = this.paginator.itemsPerPage
        obj.ultimo = this.paginator.pageStart

        EventBus.$emit("loading", true)
        this.$axios.post(this.$hostname + this.$hName + "/configuracion-recurrente/ConsultaConfRecurrenteContratos", obj, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              EventBus.$emit("loading", false)
              // this.GetDataFact(res.data)
              ;(this.TotalRegistros = res.data.TbTotalItem), (this.listContrato = res.data.ListItems)
            })
            .catch((error) => {
              EventBus.$emit("loading", false)
              this.alerta("Reporte no Impreso(" + error + ")", "error")
            })
      } else {
        this.alerta("Los campos en rojo son requeridos", "error")
      }
    },

  cargarCliente() {

      this.$axios.get(this.$hostname + this.$hName + '/clientes/findtodo/a/3/25/0', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RCliente = res.data))

    },

     // Comprobando si el valor de la entrada es nulo o indefinido.
        SelctCbClienteConsultFilt() {
          var _this = this
          setTimeout(function() {
            if (_this.ConsultaFiltro.cliente == null) {
              _this.ConsultaFiltro.cliente = ""
            }
    
            if (!_this.ConsultaFiltro.cliente.hasOwnProperty("codigo")) {
              _this.ConsultaFiltro.cliente = ""
              _this.ConsultaFiltro.cliente = null
              //  _this.alerta("Seleccione un cliente", "error");
              return
            }
          }, 300)
        },

    // Hacer una llamada API al servidor y devolver los datos al cliente.
    CbFilcliente(e) {

      if (e.target.value.length >= 0) {

        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            '/clientes/findtodo/' + (e.target.value === null || e.target.value.length==0 ? 'A' : e.target.value)  + '/3/25/0',
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then(res => (this.RCliente = res.data));
      }

    },

    // Un método que se llama cuando un usuario selecciona un cliente de una lista desplegable.

    ClienteSelectTel(e) {

      if (e != null) {
        if (e.hasOwnProperty('codigo')) {

          //this.ObjCliente=e
          this.BasicclientTel = 'Tel.' + e.cedrnc


        } else {
          this.BasicclientTel = ''
        }

      }

    },

      // Llamar a la API y obtener los datos de la API.
    cargarProyecto() {

      var headers = this.$store.getters.GetheadersAxios
      this.$axios.get(this.$hostname + this.$hName + "/Proyecto/findallActivos/", { headers: headers })
        .then(res => (this.Rproyecto = res.data))
        .catch(error => console.log(error));

    },


     // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbProyectoFiltro() {
  var _this = this
          setTimeout(function() {
            if (_this.ConsultaFiltro.proyecto == null) {
              _this.ConsultaFiltro.proyecto = ""
            }
    
            if (!_this.ConsultaFiltro.proyecto.hasOwnProperty("id")) {
              _this.ConsultaFiltro.proyecto = ""
              _this.ConsultaFiltro.proyecto = null
              //  _this.alerta("Seleccione un cliente", "error");
              return
            }
          }, 300)

    },

    getListFactcontrato(ITEM){

      if(ITEM.value==true){
        this.loaderTabla=true
        //var headers = this.$store.getters.GetheadersAxios
         this.$axios.get(this.$hostname + this.$hName + "/configuracion-recurrente/consultaFacturasContratoRecurrente/" + ITEM.item.id + "/", 
         { headers: this.$store.getters.GetheadersAxios, })
         .then(res => {
          /*let pdfWindow = window.open("Reporte de imprecion")
          pdfWindow.document.write("<embed width='100%' height='100%' type='application/pdf'   src='data:application/pdf;base64," +
            encodeURI(res.data) + "'></embed>")*/
            this.listfactContrato=res.data.ListFactura
            this.loaderTablaCargar()

        })
          .catch(error => { this.loaderTablaCargar(); EventBus.$emit("loading", false); }
          );

        
      }else{
        this.listfactContrato=[]
      }

    },


 BlurDesde() {
      if (this.ConsultaFiltro.fechaInicial.toString().length == 0) {
        this.ConsultaFiltro.fechaInicial = this.fechaNueva()
      }
    },

    BlurHasta() {
      if (this.ConsultaFiltro.fechaFinal.toString().length == 0) {
        this.ConsultaFiltro.fechaFinal = this.fechaNueva()
      }
    },

    
loaderTablaCargar(){
      this.loaderTabla=true
var _this=this;
setTimeout(function(){ _this.loaderTabla=false }, 900);
    },

ImpPedi(e) {

  this.notifImpPdf(e)
 /* EventBus.$emit("loading", true);
      var obj = {
        secuencia: e.pedidoAlmacenPK.codigo,
        documento: e.pedidoAlmacenPK.documento,
        titulo: "Pedidos a Sucursales / Almacen",
      };
      EventBus.$emit("loading", false);*/

},
SubTablaSoloItemsExpander(e){
if(this.expanded.length>0 && this.expanded[0].id===e.id){
return true;
}else{
return false;
}
},


 notifImpPdf(notifConfAdicional){
        this.notifConfAdicional= {
      estado: true,
      nombre: `\n¿Desea Imprimir o generar PDF?`,
      Exec: "contImpPdf",
      objTemp: notifConfAdicional,
    }

    return
      },

      cerrarNotificacion(){
this.notifConfAdicional= {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    }
},

SelctCbImpresora() {
      var _this = this
      setTimeout(function() {
        if (_this.notifConfAdicional.Impresora == null) {
          _this.notifConfAdicional.Impresora = ""
        }

        if (!_this.notifConfAdicional.Impresora.hasOwnProperty("codigo")) {
          _this.notifConfAdicional.Impresora = ""
          _this.notifConfAdicional.Impresora = null
          return
        }
      }, 300)

    },

claseColorEstado(e){
      var COLOR=" blue--text "
      //Aceptado: green--text  ,Rechazado: red--text ,Reenviado: orange--text ,N/A: blue--text 
      if(e!=null && e.includes('estado')&& typeof JSON.parse(e) ==="object"){
        var ESTADO=JSON.parse(e).estado
        if(ESTADO.includes('Aceptado')){ COLOR=" green--text "}
        if(ESTADO.includes('Rechazado')){ COLOR=" red--text "}
        // if(ESTADO.includes('Reenviado')){ COLOR=" orange--text "}
      }else{
        COLOR=" blue--text "
      }
      return COLOR
    },
    getEstado(e){
      var ESTADO="N/A"
      if(e!=null && e.includes('estado')&&  typeof JSON.parse(e) ==="object"){
      ESTADO=JSON.parse(e).estado
      }
      return ESTADO
    },

     cargarImpresoras() {
      var header = {
        mode: "no-cors",
        header: {
          "Access-Control-Allow-Origin": "*",
          "origin": "x-requested-with",
          "Access-Control-Allow-Headers": "POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin",
          "Content-Type": "application/json",
        },
      }
      this.$axios
        .get("http://localhost:15999/impresora/inicial/listaImpresora", header)
        .then((res) => {
          if (res.data.length > 0) {
            this.impList = res.data[0].impresoras
            //this.form.imprimirEtiqueta.Impresora = res.data[0].defaulPrinter;
          }
        })
    },

async imprimirPrint(){

if(this.notifConfAdicional.Impresora==null){
  this.alerta("Seleccione una Impresora", "error")
  return
}





//fac.factura
   /*var msg = {
           accion: "reprint",
           formato: this.caja.formatoimpresioncontado.trim(),
           //  impresora: JSON.parse(localStorage.printerSelect).nombre,
           impresora: impresora,
           data: this.configuraciones,
           fac: this.ReimprecionFacturaSeleccionada,
           cajero: this.OtrasConfigPv.cajero,
           caja: this.caja,
         }   */

var FACT=this.notifConfAdicional.objTemp
FACT.DetalleList=FACT.facturasventaDetalleList
FACT.factura=JSON.parse(JSON.stringify(FACT))
FACT.factura.factura=JSON.parse(JSON.stringify(FACT))
var Obj = {
  accion: "reprint",
  formato: FACT.caja.formatoimpresioncontado.trim(),
  data:this.$store.getters.GetConfiguracionGeneral,
  fac:FACT,
  // fac:{factura:{factura:FACT}},
  Impresora:this.notifConfAdicional.Impresora,
  impresora: this.notifConfAdicional.Impresora.nombre,
  caja: FACT.caja,
  cajero:this.$store.getters.GetOtrasConfigPv.cajero,
  schema : this.$store.getters.GetheadersAxios["X-TENANT-ID"]
  
}
//Obj.fac=JSON.parse(JSON.stringify(FACT))


this.imprimir(Obj, "factura");
    },

  reportePdf(){

    console.log('reportePdf-->',this.notifConfAdicional.objTemp)
    var FAC=this.notifConfAdicional.objTemp
  
    var OBJ=FAC.facturasventaPK
 if(FAC.hasOwnProperty('qrdgii') && FAC.qrdgii!=null && FAC.qrdgii.trim().length>0){
      OBJ.qrdgii=FAC.qrdgii
      OBJ.signatureValue=FAC.signatureValue
      OBJ.fechafirmadgii=FAC.fechafirmadgii
      }else{
      OBJ.qrdgii=null
      OBJ.signatureValue=null
      OBJ.fechafirmadgii=null 
      }

       OBJ.where=` and fv.documento=${OBJ.documento} and fv.secuencia=${OBJ.secuencia}`

  //this.imprimirList()
  // var _this = this
  //       setTimeout(function () {
  //         _this.$refs.RefComponentsModRepBas.ReporteImprimir()
  //         _this.dialogimprimirList = false
  //       }, 100)

        EventBus.$emit("loading", true);
        var headers = this.$store.getters.GetheadersAxios
        this.$axios.post(this.$hostname + this.$hName + "/configuracion-recurrente/ImprGenerarFactRecurrentes/",OBJ, { headers: headers })
        .then(res => {
          EventBus.$emit("loading", false);
            var PDF=`data:application/pdf;base64,${encodeURI(res.data)}`;
            EventBus.$emit("openPDF",PDF ,'conf recurrente');
        })
          .catch(error => { EventBus.$emit("loading", false); });

    





},


imprimir(datos, operacion) {
      EventBus.$emit("loading", true)
      datos.operacion = operacion
      this.$axios
        .post("http://localhost:15999/impresora/imprimir", datos)
        .then((res) => {
          EventBus.$emit("loading", false)
          //this.limpiarPuntoVentaCompleto();
        })
        .catch((error) => {
          EventBus.$emit("loading", false)
          console.error(error)
        })

    },

    buscarConsultaFacRecurrent(){
//@input="getContratoList" v-on:input="resertPaginacion" 

  this.resertPaginacion()

var _this = this
      setTimeout(function () {
        _this.getContratoList()
      }, 800)


    },

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
        EventBus.$emit("loading", false);
      }
      if (l == "warning") {
        (this.aalert.estado = true),
          (this.aalert.color = "warning"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
        EventBus.$emit("loading", false);

      }
      this.loaderTabla=false
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
      await this.$axios
        .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
          usuario: JSON.parse(JSON.stringify(this.$user))
        })
        .then(res => {
          this.list = res.data;
        });
    }
  },
  computed: {
    ActDescBtn() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
    }
  }




};
</script>

<style>

</style>
